import { defineMessages } from 'react-intl';

export default defineMessages({
  paymentSummary: {
    id: 'PaymentSummary.paymentSummary',
    defaultMessage: 'Payment Summary',
  },
  paymentType: {
    id: 'PaymentDetail.paymentType',
    defaultMessage: 'Payment Type:',
  },
  orderId: {
    id: 'PaymentDetail.orderId',
    defaultMessage: 'Order ID:',
  },
  ongoingOrderId: {
    id: 'PaymentDetail.ongoingOrderId',
    defaultMessage: 'Ongoing Order ID:',
  },
  total: {
    id: 'TransactionsList.total',
    defaultMessage: 'Total',
  },
  onGoingOrderWarning: {
    id: 'TransactionsList.onGoingOrderWarning',
    defaultMessage:
      'This is an ongoing order for the period ending {endingDate}. Charges are subject to change.',
  },
  failed: {
    id: 'TransactionsList.failed',
    defaultMessage: 'Failed',
  },
  includesPreviousCharges: {
    id: 'TransactionsList.includesPreviousCharges',
    defaultMessage: 'Includes failed charges from a previous day',
  },
});
